import Script from 'next/script';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect } from 'react';
import { useAnonymousAmplitudeTracking } from '@/components/analytics/hooks/useAnonymousAmplitudeTracking';
import { getAmplitudeExperimentScriptSrc } from '@/lib/analytics/amplitude/client';
import { applyAmplitudeConsent } from '@/lib/analytics/amplitude/consentOrchestrator';
import { useAmplitudeEnabled } from '@/lib/analytics/amplitude/useAmplitudeEnabled';
import { getConsent, useConsentHandler } from '@/lib/consent';

const AmplitudeExperimentScript = () => {
  const anonymousTrackingEnabled =
    useFeatureValue('PD-6269-amplitude_anonymous_tracking-web', false) === true;
  useAnonymousAmplitudeTracking(anonymousTrackingEnabled);

  // Amplitude is the reference consumer of the consent registry: it enables/tears itself down on consent changes without the consent provider knowing Amplitude exists.
  useConsentHandler('amplitude', (snapshot) =>
    applyAmplitudeConsent(snapshot, anonymousTrackingEnabled)
  );

  useEffect(() => {
    // GrowthBook updates do not emit a consent event, so replay the current consent state.
    applyAmplitudeConsent(getConsent(), anonymousTrackingEnabled);
  }, [anonymousTrackingEnabled]);

  const amplitudeEnabled = useAmplitudeEnabled();
  const amplitudeExperimentScriptSrc = amplitudeEnabled ? getAmplitudeExperimentScriptSrc() : null;

  if (!amplitudeExperimentScriptSrc) {
    return null;
  }

  return (
    <Script
      id="amplitude-web-experiment"
      strategy="afterInteractive"
      src={amplitudeExperimentScriptSrc}
    />
  );
};

export default AmplitudeExperimentScript;
